import {
GET_CUSTOMER_INVOICE_LIST,
GET_INVOICE_LIST,
UPDATE_DISCOUNT,
GET_RETURN_INVOICE_LIST
} from "../../admin-constants";

const initialState = {
  invoiceList: [],
  invoicePerCustomer:[],
  returnInvoiceList: [],
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_CUSTOMER_INVOICE_LIST: {
      return {
        ...state,
        invoiceList: payload,
      };
    }
    case GET_INVOICE_LIST: {
      return {
        ...state,
        invoicePerCustomer: payload,
      };
    }
    case GET_RETURN_INVOICE_LIST: {
      return {
        ...state,
        returnInvoiceList: payload,
      };
    }
    default:
      return state;
  }
};

export default reducer;
